"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createErrorResponseSchema = exports.createSuccessResponseSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const createSuccessResponseSchema = (dataSchema) => {
    return zod_1.default.object({
        status: zod_1.default.literal('success'),
        statusCode: zod_1.default.number(),
        message: zod_1.default.string().optional().nullable(),
        timestamp: zod_1.default.string(),
        metaData: zod_1.default.record(zod_1.default.unknown()).optional(),
        data: dataSchema ? dataSchema : zod_1.default.undefined(),
    });
};
exports.createSuccessResponseSchema = createSuccessResponseSchema;
const createErrorResponseSchema = (errorDetailsSchema) => {
    return zod_1.default.object({
        status: zod_1.default.literal('error'),
        statusCode: zod_1.default.number(),
        message: zod_1.default.string().optional().nullable(),
        timestamp: zod_1.default.string(),
        metaData: zod_1.default.record(zod_1.default.unknown()).optional(),
        error: zod_1.default.object({
            errorCode: zod_1.default.union([zod_1.default.number(), zod_1.default.string()]),
            details: errorDetailsSchema,
            path: zod_1.default.string(),
        }),
    });
};
exports.createErrorResponseSchema = createErrorResponseSchema;
